import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {NavigationStart, Router} from '@angular/router';


@Injectable()
export class PageTitleService {

    private subject = new Subject<string | undefined>();

    constructor(private router: Router) {
        // clear page title on route change
        router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                this.subject.next(undefined);
            }
        });
    }

    setPageTitle(pageTitle: string) {
        this.subject.next(pageTitle);
    }

    getPageTitle(): Observable<string | undefined> {
        return this.subject.asObservable();
    }
}